import React from 'react';
import { Button } from 'semantic-ui-react';
import ReactFileReader from 'react-file-reader';

export const UploadFile = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {

    return (
        <>
            <ReactFileReader base64={true} fileTypes={props.typer}
                handleFiles={(value) => setFieldValue(name, value)}
                {...props}
                btnStyle={{ width: "max-content" }}
            >
                <Button className={props.classNameBtn} color={props.clrd} basic type="button" size="tiny" icon>
                    <i className="fas fa-upload"></i> {props.buttonName}
                </Button>
            </ReactFileReader>
        </>
    )
}

// export default UploadFile